import { ActionTypes } from '../../enums/action-types';
import { ObjectTypeEnum } from '../../enums/object-types';
import { Location } from '../../models';

export interface ServiceRequest {
  id?: string;
  objectType?: ObjectTypeEnum;
  action: number;
  size: string;
  weight: number;
  locationId: Location;
  createdAt?: string;
  jobNumber: string;
  LC_Code?: string;
  product?: string;
  tripInfo?: string;
  description?: string;
  planId: string;
  jobId?: string;
  systemLocationId?: string;
  sequenceNumber : number;
  distributionLaneId?: string;
  customData?: any;
}